import { api } from './api';
import { Conversation } from '../types/conversation';
import {
  Contact,
  CreateContactRequest,
  UpdateContactRequest,
} from '../types/contact';

class ContactService {
  async getAll(): Promise<Contact[]> {
    const response = await api.get<Contact[]>('/contacts');
    return response.data;
  }

  async getById(id: string): Promise<Contact> {
    const response = await api.get<Contact>(`/contacts/${id}`);
    return response.data;
  }

  async getConversations(id: string): Promise<Conversation[]> {
    const response = await api.get<Conversation[]>(`/contacts/${id}/conversations`);
    return response.data;
  }

  async create(data: CreateContactRequest): Promise<Contact> {
    const response = await api.post<Contact>('/contacts', data);
    return response.data;
  }

  async update(id: string, data: UpdateContactRequest): Promise<Contact> {
    const response = await api.put<Contact>(`/contacts/${id}`, data);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/contacts/${id}`);
  }
}

export const contactService = new ContactService();
